import { render, staticRenderFns } from "./SavedSearchMetaChips.vue?vue&type=template&id=39eed150"
import script from "./SavedSearchMetaChips.vue?vue&type=script&lang=js"
export * from "./SavedSearchMetaChips.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchMetaChips.vue?vue&type=style&index=0&id=39eed150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports